<template>
    <div>
        <el-switch v-model="value" :active-text="getStateText()" active-color="#70CE97" inactive-color="#cccccc"></el-switch>
    </div>
</template>
<script>
export default {
    name: 'ybStateSwitch',
    data () {
        return {
            value: true
        }
    },
    methods: {
        getStateText (value) {
            return this.value ? '启用' : '禁用';
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
